"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var link_action_button_creator_1 = require("../util/link-action-button-creator");
var commit_1 = require("./svg/commit");
exports.default = link_action_button_creator_1.default({
    children: React.createElement(commit_1.default, null)
});
